import GameServerPublicInfo from "../../models/GameServerPublicInfo";
import axios from "axios";
import BackendClient from "../../BackendClient";


export function getExpansionColors(client: BackendClient): Promise<Array<string>> {
  return new Promise<Array<string>>((resolve, reject) => {
    axios.get(`${client.getBackendUrl()}${BackendClient.GetPublicExpansionColors}`)
      .then((response) => resolve(response.data))
      .catch((reason) => {
        console.log(`Exception when fetching expansion colors info: ${JSON.stringify(reason)}`);
        reject(reason);
      });
  });
}